import { FaArrowLeft } from "react-icons/fa";
import { InputSearch } from "../../inputs/InputSearch";
import { useFormSearch } from "../../../../hooks/useFormSearch";
import { useCategoriesStore, useSearchStore, useUIStore } from "../../../../store";
import styles from "./FormSearch.module.scss";

export const FormSearch = () => {
  // Traemos todo desde nuestro hook actualizado
  const {
    inputValue,
    setInputValue
  } = useFormSearch();

  // Traemos el clearSearch para la "X"
  const clearSearch = useSearchStore((s) => s.clearSearch);

  const closeSearch = useUIStore((s) => s.closeSearch);

  const setIsSticky = useUIStore((s) => s.setIsSticky);

  const setCategorySelected = useCategoriesStore(
    (s) => s.setCategorySelected
  );

  const handleClose = () => {
    clearSearch();
    setCategorySelected(null);
    setIsSticky(false);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    closeSearch();
  };

  return (
    <form
      className={`${styles.containerFormSearch}`}
      onSubmit={(e) => e.preventDefault()}
    >
      <button type="button" className={styles.backBtn} onClick={handleClose}>
        <FaArrowLeft className={styles.iconBack} />
      </button>

      <InputSearch
        value={inputValue}
        // 🔥 Actualiza el store global en cada tecla
        handleChange={(e) => setInputValue(e.target.value)}
        handleClear={clearSearch}
      />
    </form>
  );
};